import { useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { ErrorBoundary } from '@sentry/react';
import { useTranslation } from 'react-i18next';
import { userDefaultTeamIdsAtom } from '@/atoms/queries/teams';
import {
  AppShellErrorFallback,
  AppShellFullLoadingFallback,
  AppShellLoadingFallback,
} from '../layout/AppShellFallback';

const RedirectToTeamBase = ({ teamId }: { teamId?: number | null }) => {
  const {
    i18n: { language: locale },
  } = useTranslation();
  return (
    <AppShellFullLoadingFallback>
      <Navigate to={`/${locale}/team/${teamId}/dashboard`} replace />
    </AppShellFullLoadingFallback>
  );
};
const RedirectToTeamWithData = () => {
  const userDefaultTeamId = useAtomValue(userDefaultTeamIdsAtom)?.datahubId;

  return <RedirectToTeamBase teamId={userDefaultTeamId} />;
};

export const RedirectToTeam = () => (
  <Suspense fallback={<AppShellLoadingFallback />}>
    <ErrorBoundary fallback={<AppShellErrorFallback />}>
      <RedirectToTeamWithData />
    </ErrorBoundary>
  </Suspense>
);
